export const BASE_URL = process.env.REACT_APP_BASEURL;
export const url = process.env.REACT_APP_urlconst;
export const attachmentURL = process.env.REACT_APP_attachmentURL;
export const SecretKey = process.env.REACT_APP_SecretKey;
export const SecretKey2 =process.env.REACT_APP_SecretKey2;
export const REACT_APP_TWILLIO_NU = process.env.REACT_APP_TWILLIO_NU;
export const REACT_APP_ANDROID_INSTALLATION_LINK=process.env.REACT_APP_ANDROID_INSTALLATION_LINK;
export const REACT_APP_IOS_INSTALLATION_LINK=process.env.REACT_APP_IOS_INSTALLATION_LINK;



